module.exports = __webpack_public_path__ + "img/Pano_4.ba1f9494.jpg";